import React from 'react'
import {
  Box,
  Button,
  alpha,
  useTheme
} from '@mui/material'

export const EmailSendAccBtn = ({ value, handleSubmit, onCancel }) => {
  const theme = useTheme()
  return (
    <>
      <Box sx={{ mt: 3, mb: 2 }}>
        <Button
          variant='contained'
          size='small'
          onClick={() => { handleSubmit(value) }}
          sx={{
            bgcolor: theme.palette.primary.main,
            '&:hover': {
              bgcolor: alpha(theme.palette.primary.main, 0.9)
            }
          }}
          className='text-end'
        >
          Save
        </Button>

        <Button
          variant='contained'
          size='small'
          onClick={onCancel}
          sx={{
            bgcolor: theme.palette.error.main,
            margin: '5px',
            '&:hover': {
              bgcolor: alpha(theme.palette.error.light, 0.9)
            }
          }}
          className='text-end'
        >
          Cancel
        </Button>
      </Box>
    </>
  )
}
